import { render, staticRenderFns } from "./social-buttons.vue?vue&type=template&id=b8c2b384&scoped=true"
import script from "./social-buttons.vue?vue&type=script&lang=js"
export * from "./social-buttons.vue?vue&type=script&lang=js"
import style0 from "./social-buttons.vue?vue&type=style&index=0&id=b8c2b384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c2b384",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
